import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type AuthPasswordFieldProps = {
    id: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
    autoFocus?: boolean;
    required?: boolean;
};

const AuthPasswordField = ({
    id,
    value,
    onChange,
    placeholder,
    autoFocus = true,
    required = false,
}: AuthPasswordFieldProps) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className="gs-auth-field-wrap">
            <Input
                id={id}
                type={visible ? "text" : "password"}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoFocus={autoFocus}
                required={required}
                autoComplete="off"
                className={cn("gs-auth-input-lg pr-10")}
            />
            <button
                type="button"
                tabIndex={-1}
                className="gs-auth-password-toggle"
                onClick={() => setVisible((show) => !show)}
                aria-label={visible ? "Hide password" : "Show password"}
            >
                {visible ? (
                    <EyeOff id={`${id}-icon`} className="size-[1.125rem]" />
                ) : (
                    <Eye id={`${id}-icon`} className="size-[1.125rem]" />
                )}
            </button>
        </div>
    );
};

export default AuthPasswordField;
